import {takeEvery} from "redux-saga/effects";
import {cardsActions} from "../cards.slice";
import {loadCardSaga} from "./_sagas/loadCard.saga";

export function* cardDownloaderSaga() {
    yield takeEvery(cardsActions.loadCard.type, loadCardSaga);
}
